import { UserPlus, Stethoscope, ShieldAlert, UserCheck, Package, GraduationCap } from "lucide-react";

export const QUICK_ACTIONS = [
  { k: "recrutement", l: "Demande de recrutement", icon: UserPlus, c: "text-violet-600 bg-violet-50" },
  { k: "absence", l: "Déclaration absence / arrêt", icon: Stethoscope, c: "text-rose-600 bg-rose-50" },
  { k: "dossier", l: "Disciplinaire / Dossier RH", icon: ShieldAlert, c: "text-orange-600 bg-orange-50" },
  { k: "integration", l: "Intégration", icon: UserCheck, c: "text-emerald-600 bg-emerald-50" },
  { k: "equipement", l: "Demande d'équipement", icon: Package, c: "text-amber-600 bg-amber-50" },
  { k: "formation", l: "Formation", icon: GraduationCap, c: "text-blue-600 bg-blue-50" },
];

export function RhQuickActions({ onOpen }) {
  return <div className="sticky top-[60px] z-10 bg-white/90 backdrop-blur border border-slate-200 rounded-2xl px-2 py-1.5 flex gap-1.5 overflow-x-auto shadow-sm" data-testid="rh-quick-actions">
    {QUICK_ACTIONS.map(a => <button key={a.k} onClick={() => onOpen(a.k)} data-testid={`rh-quick-${a.k}`} className="flex items-center gap-2 px-3 py-2 rounded-xl text-xs font-semibold text-slate-700 hover:bg-slate-50 border border-transparent hover:border-slate-200 whitespace-nowrap transition-colors">
      <span className={`w-6 h-6 rounded-lg grid place-items-center ${a.c}`}><a.icon className="w-3.5 h-3.5" /></span>{a.l}</button>)}
  </div>;
}
